import { useMemo } from "react";
import { ClassicChevronRightIcon } from "../../AscIcons";
import classNames from "classnames";
import styles from "./AscAddModuleDetails.module.scss";

export interface AscAddModuleDetailsProps {
  className?: string;
  value: number;
}

export default function AscAddModuleDetails({
  className,
  value,
}: AscAddModuleDetailsProps) {
  const steps = useMemo(() => {
    const _steps = [];

    const text = ["Module info", "Survey", "Content", "Activities", "Feedback"];

    for (let i = 1; i <= text.length; i++) {
      _steps.push(
        <AscDetailsStep
          key={i}
          active={i <= value}
          number={i}
          text={text[i - 1]}
          icon={<ClassicChevronRightIcon className={styles.icon} />}
        />
      );
    }

    return _steps;
  }, [value]);

  return (
    <div
      data-testid="asc-activities-add-module"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.steps}>{steps}</div>
    </div>
  );
}

interface AscDetailsStepProps {
  active?: boolean;
  text: string;
  number: number;
  icon?: React.ReactNode;
}
function AscDetailsStep({ active, text, number, icon }: AscDetailsStepProps) {
  return (
    <div className={classNames(styles.progressStep)}>
      <span
        className={classNames(styles.number, {
          [styles.active]: active,
        })}
      >
        {number}
      </span>

      <span className={styles.text}>{text}</span>

      {number === 5 ? null : icon}
    </div>
  );
}
